$(document).ready(function ($) {
	let animationRunning = false;
	let animationTimeout;

	const animationSequence = [
		{
			order: 1,
			hasStatus: true,
			statusType: 'clicked',
			hasChartData: true,
			chartSegment: 'opportunity-segment',
			startImage:
				'/wp-content/uploads/2026/01/profile-chart-thumbnail-image-set-1-start.svg',
			endImage:
				'/wp-content/uploads/2026/01/profile-chart-thumbnail-image-set-1-end.svg',
			scores: {
				Opportunity: '100%',
			},
		},
		{
			order: 2,
			hasStatus: false,
			hasChartData: false,
		},
		{
			order: 3,
			hasStatus: true,
			statusType: 'clicked',
			hasChartData: true,
			chartSegment: 'urgency-segment',
			startImage:
				'/wp-content/uploads/2026/01/profile-chart-thumbnail-image-set-2-start.svg',
			endImage:
				'/wp-content/uploads/2026/01/profile-chart-thumbnail-image-set-2-end.svg',
			scores: {
				Urgency: '50%',
				Opportunity: '50%',
			},
		},
		{
			order: 4,
			hasStatus: false,
			hasChartData: false,
		},
		{
			order: 5,
			hasStatus: true,
			statusType: 'reported',
			hasChartData: true,
			chartSegment: 'greed-segment',
			scores: {
				Greed: '0%',
			},
			greedIcon: '/wp-content/uploads/2025/10/icon-guard-check.svg',
		},
		{
			order: 6,
			hasStatus: true,
			statusType: 'clicked',
			hasChartData: true,
			chartSegment: 'obedience-segment',
			startImage:
				'/wp-content/uploads/2026/01/profile-chart-thumbnail-image-set-3-start.svg',
			endImage:
				'/wp-content/uploads/2026/01/profile-chart-thumbnail-image-set-3-end.svg',
			scores: {
				Obedience: '33%',
				Urgency: '33%',
				Opportunity: '33%',
			},
		},
		{
			order: 7,
			hasStatus: false,
			hasChartData: false,
		},
	];

	function startAnimation() {
		if (animationRunning) return;

		animationRunning = true;

		animateNextItem(0);
	}

	function animateNextItem(index) {
		if (index >= animationSequence.length) {
			setTimeout(() => {
				animationRunning = false;
			}, 1000);
			return;
		}

		const config = animationSequence[index];
		animateTrainingInstance(config, () => {
			setTimeout(() => {
				animateNextItem(index + 1);
			}, 2000);
		});
	}

	function updateLineHeights() {
		const isMobile = $(window).width() <= 768;
		if (!isMobile) return;

		// Get the training list and its position
		const $trainingList = $('.training-list');
		const listOffset = $trainingList.offset();
		if (!listOffset) return;

		const listTop = listOffset.top;

		// Calculate heights for each revealed instance
		for (let i = 1; i <= 7; i++) {
			const $instance = $(
				`.training-instance[data-animation-order="${i}"]`
			);

			if ($instance.length && $instance.hasClass('revealed')) {
				// Only create rule if it doesn't exist yet
				if ($(`#dynamic-line-heights-${i}`).length === 0) {
					const instanceOffset = $instance.offset();
					if (instanceOffset) {
						// Calculate height from list top to instance icon center
						const instanceTop = instanceOffset.top;
						const iconHeight = 24; // icon height
						const calculatedHeight = Math.max(
							0,
							instanceTop - listTop + iconHeight / 2
						);

						// Create and inject CSS rule
						const cssRule = `.training-list.show-to-${i}::after { height: ${calculatedHeight}px !important; }`;
						$('<style>')
							.attr('id', `dynamic-line-heights-${i}`)
							.text(cssRule)
							.appendTo('head');
					}
				}
			}
		}
	}

	function animateTrainingInstance(config, callback) {
		const instance = $(
			`.training-instance[data-animation-order="${config.order}"]`
		);

		instance.addClass('revealed animate');

		$('.content-wrapper')
			.removeClass(
				'show-to-1 show-to-2 show-to-3 show-to-4 show-to-5 show-to-6 show-to-7'
			)
			.addClass(`show-to-${config.order}`);
		$('.training-list')
			.removeClass(
				'show-to-1 show-to-2 show-to-3 show-to-4 show-to-5 show-to-6 show-to-7'
			)
			.addClass(`show-to-${config.order}`);

		// Update line heights after instance is revealed and positioned
		setTimeout(() => {
			updateLineHeights();
		}, 500);

		if (config.hasStatus) {
			setTimeout(() => {
				const badge = instance.find('.instance-badge');
				badge.show().addClass('show animate');

				if (config.hasChartData && config.scores) {
					animateChartAndScores(config);
				}

				setTimeout(() => {
					if (config.endImage) {
						const tempImg = new Image();
						tempImg.onload = function () {
							if (callback) callback();
						};
						tempImg.onerror = function () {
							if (callback) callback();
						};
						tempImg.src = config.endImage;
					} else if (callback) callback();
				}, 1000);
			}, 2000);
		} else {
			if (config.hasChartData && config.scores) {
				setTimeout(() => {
					animateChartAndScores(config);
				}, 1000);
			}

			if (callback) callback();
		}
	}

	function animateChartAndScores(data) {
		const $profilePhoto = $('.profile-photo img');

		if (data.startImage) {
			changeImageWithCrossfade($('.profile-photo'), data.startImage);
		}

		if (data.scores) {
			Object.keys(data.scores).forEach((scoreType) => {
				const $scoreItem = $(`.score-item.${scoreType}`);
				const $scoreValue = $scoreItem.find('.score-value');

				$scoreItem.removeClass('placeholder').addClass('show');

				$scoreItem
					.next('.score-divider')
					.removeClass('placeholder')
					.addClass('show');

				if (scoreType === 'Greed' && data.scores[scoreType] === '0%') {
					$scoreValue
						.removeClass('icon-mode')
						.text(data.scores[scoreType]);
				} else {
					$scoreValue.text(data.scores[scoreType]);
				}
			});
		}

		setTimeout(() => {
			if (data.endImage) {
				changeImageWithCrossfade($('.profile-photo'), data.endImage);
			}

			if (data.greedIcon) {
				const $greedScore = $('.score-item.Greed .score-value');
				$greedScore
					.addClass('icon-mode')
					.html(`<img src="${data.greedIcon}" alt="Guard Check" />`);
			}
		}, 2000);
	}

	function changeImageWithCrossfade($container, newSrc) {
		const $currentImg = $container.find('img');

		// Check if mobile viewport (768px or less)
		if ($(window).width() <= 768) {
			// Mobile: Direct image replacement without crossfade
			$currentImg.attr('src', newSrc);
			return;
		}

		const $newImg = $('<img>')
			.attr('src', newSrc)
			.attr('alt', $currentImg.attr('alt'))
			.addClass('crossfade-out')
			.css('z-index', '2');

		$container.append($newImg);

		$newImg.on('load', function () {
			$newImg.removeClass('crossfade-out').addClass('crossfade-in');
			$currentImg.addClass('crossfade-out');

			setTimeout(() => {
				$currentImg.remove();
				$newImg.removeClass('crossfade-in').css('z-index', '1');
			}, 600);
		});

		$newImg.on('error', function () {
			$newImg.remove();
		});
	}

	function setupScrollTrigger() {
		const animationSection = $('.animation-container');
		let hasTriggered = false;

		function checkScrollPosition() {
			if (hasTriggered) return;

			const sectionTop = animationSection.offset().top;
			const sectionHeight = animationSection.height();
			const windowTop = $(window).scrollTop();
			const windowHeight = $(window).height();

			const triggerPoint = sectionTop - windowHeight * 0.3;

			if (windowTop >= triggerPoint) {
				hasTriggered = true;
				// Update line heights before starting animation
				updateLineHeights();
				startAnimation();
				console.log('animation start');
			}
		}

		$(window).on('scroll', checkScrollPosition);
		checkScrollPosition();
	}

	setupScrollTrigger();

	// Update line heights on window resize
	$(window).on('resize', function () {
		clearTimeout(window.resizeTimeout);
		window.resizeTimeout = setTimeout(function () {
			updateLineHeights();
		}, 250);
	});

	$('.training-instance')
		.on('mouseenter', function () {
			if (!animationRunning && $(this).hasClass('revealed')) {
				$(this).css('transform', 'translateX(5px)');
			}
		})
		.on('mouseleave', function () {
			$(this).css('transform', 'translateX(0)');
		});
});
